/* eslint-disable no-use-before-define,no-mixed-operators */
import React from 'react'
import { hideModal, arrayFrom, fmt } from '../twd'

export default ({issue={}, } = {}) => {

    let steps = arrayFrom(issue.stepSchedule)

    return <React.Fragment>
    <div className="modal-dialog modal-sm">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-multi-step-coupon-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center">Multi-Step Coupon</h3>

            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-multi-step-coupon-table'
                className="table align-top table-striped"
            >
            <thead>
                <tr>
                <th>Date</th>
                <th className='text-right'>Coupon</th>
                </tr>
            </thead>
            <tbody>{
                steps.map((s,i)=> {
                    return <tr key={i}>
                        <td>{fmt.mdy(s.dt)}</td>
                        <td className='text-right'>{cpn2(s.coupon)}</td>
                    </tr>
                })

            }</tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}


let cpn2 = (a) => {
    let x = Number.parseFloat(a)
    return isNaN(x) ? fmt.empty() : x.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2})
}

